module.exports = __webpack_public_path__ + "img/logo-color.ef558610.svg";